import { Button } from 'antd';
import React from 'react';

function CommonButton({ children, ...props }) {
  return (
    <div>
      <Button {...props}>{children}</Button>
    </div>
  );
}

export default CommonButton;
